var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ctrl-value-commercers"},[_c('el-row',[_c('el-col',[_c('h2',[_vm._v("バリューコマース公開設定")])])],1),_c('ValueCommercerList')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }